<div class="lesson-status-legend">
	<h3>Lesson Statuses</h3>
	<div class="legend-items">
		@for (status of statuses; track status) {
			<div class="legend-item">
				<div class="status-indicator" [ngClass]="statusConfig[status].colorClass">
					<md-icon [icon]="statusConfig[status].icon"></md-icon>
				</div>
				<span>{{ statusConfig[status].label }}</span>
			</div>
		}
	</div>
</div>
